export default __webpack_public_path__ + "static/media/1878.a64844bb.png";